import { render, staticRenderFns } from "./attachmDialog.vue?vue&type=template&id=634ba2d0&scoped=true&"
import script from "./attachmDialog.vue?vue&type=script&lang=js&"
export * from "./attachmDialog.vue?vue&type=script&lang=js&"
import style1 from "./attachmDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634ba2d0",
  null
  
)

export default component.exports